import { createFileRoute } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { DeliveryOverview } from '~/components/deliveries/deliveryOverview';

import { routeParams, validateSearch } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.list, { ns: 'delivery' });

export const Route = createFileRoute('/(main)/deliveries/all/')({
  beforeLoad: createProtectedRoute({
    routePath: '/deliveries/all/',
    ...routeParams,
  }),
  component: DeliveryOverview,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch,
});

export const DELIVERIES = buildRouteExport({
  Route,
  ...routeParams,
});
